import { FavouriteUrl } from "core/types/favourite-url.types";
import { Dispatch } from "../../store.types";
import * as actions from "./report.actions";
import { reportApi } from "core/api";
import i18n from "i18n";

export const generateReport =
  (results: any[], practiceId: number) => async (dispatch: Dispatch) => {
    dispatch(actions.isReportLoading({ isReportLoading: true }));
    try {
      await reportApi.generateReport(results, practiceId);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(actions.reportSuccess({ reportSuccess: "ok" }));
      dispatch(actions.isReportLoading({ isReportLoading: false }));
    }
  };

export const getAllReports = () => async (dispatch: Dispatch) => {
  dispatch(actions.isReportLoading({ isReportLoading: true }));
  try {
    const reports = await reportApi.getList();
    dispatch(actions.reportList({ reportList: reports }));
  } catch (error) {
    console.log(error);
  } finally {
    dispatch(actions.reportSuccess({ reportSuccess: "ok" }));
    dispatch(actions.isReportLoading({ isReportLoading: false }));
  }
};

export const downloadReport =
  (fileId: number) => async (dispatch: Dispatch) => {
    dispatch(
      actions.isDownloadReportLoading({ isDownloadReportLoading: true })
    );
    try {
      const response = await reportApi.download(fileId);
      // 204 (file non tuo o inesistente) arriva come successo con corpo vuoto: salvarlo produceva
      // uno zip da 0 KB che sembrava un report rotto.
      if (!response || !response.byteLength) {
        window.alert(i18n.t("report.download_empty"));
        return;
      }
      let blob = new Blob([response], { type: "application/zip" });
      let url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Report_n${fileId}.zip`);
      document.body.appendChild(link);
      link.click();
      link?.parentNode?.removeChild(link);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(
        actions.isDownloadReportLoading({ isDownloadReportLoading: false })
      );
    }
  };

export const getAllSocialReports = () => async (dispatch: Dispatch) => {
  dispatch(actions.isReportLoading({ isReportLoading: true }));
  try {
    const reports = await reportApi.getSocialList();
    dispatch(actions.reportList({ reportList: reports }));
  } catch (error) {
    console.log(error);
  } finally {
    dispatch(actions.reportSuccess({ reportSuccess: "ok" }));
    dispatch(actions.isReportLoading({ isReportLoading: false }));
  }
};
